import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { Router, RouterOutlet } from '@angular/router';
import { SnapshotService } from '../Services/snapshot.service';
import { LoaderService } from '../../../common/services/loader.service';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { firstValueFrom, Subscription, switchMap, of } from 'rxjs';
import { set } from 'lodash';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import { CustomMetricWidgetlibraryComponent } from '../custom-metric-widgetlibrary/custom-metric-widgetlibrary.component';
import { de } from 'date-fns/locale';


@Component({
  selector: 'app-snapshot-configuaration',
  templateUrl: './snapshot-configuaration.component.html',
  styleUrls: ['./snapshot-configuaration.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnapshotConfiguarationComponent {
  isLoading: boolean = false;
  showWidgetLibraryCondition: boolean = false;
  showModuleConfigCondition: boolean = false;
  snapshotShow: boolean = false;
  clientSnapshotNames: any = [];
  isback: any = false;
  productSelectedValue = "standard";
  templateSelectedValue = "select";
  enableAdditonalConfig=false;
  showAdditonalConfigCondition=false;
  // ----------------------------
  hideClientDashboard: boolean = false;
  hideProductDropdown: boolean = false;
  hideTemplateDropdown: boolean = false;
  isNumeral: boolean=false;
  @Input() snapID: number = this.snapshotCount.snapshotCount;
  private subscriptions: Subscription = new Subscription();

  product: any = [
    { name: "Standard", value: "standard", selected: true },
    { name: "Custom", value: "custom", selected: false },
    { name: "Builder", value: "builder", selected: false }
  ];
  template: any = [
    { name: "Brand Health - MDS", value: "brandhealthmds", selected: false },
    { name: "Brand Tracker", value: "brandtracker", selected: false },
    { name: "CMX", value: "cmx", selected: false }
  ];
  enableTopicsConfig: boolean = false;
  showTopicsConfigCondition:boolean=false;

  get isTopicsEnabled(): boolean {
    const study = this.clientDetails.clientDetails.study;
    const client = this.clientDetails.clientDetails.client_name;
    if (!study || !client) return false;
    return true;
  }
  isStandardProduct: boolean = true;
  isproductselected: boolean = true;
  istemplateselected: boolean = false;
  enableWidgetLibrarySection: Boolean = false;
  @Input()showLoaderPopUp: boolean = false;
  fromngOnInit = false;
  private isUpdatingProductTemplate = false;
  private lastUpdatedSnapshot = '';
  clientStudyApiData: any = null; // Store API response to pass to child component
  @ViewChild('templatedropdown') dropdown!: ElementRef<HTMLSelectElement>;
  @ViewChild(RouterOutlet, { static: false }) outlet!: RouterOutlet;
  @ViewChild('child', { static: false }) childComponent!:  CustomMetricWidgetlibraryComponent;
  ngOnInit() {
    // this.clientDetails.snapshotCount = (this.clientDetails.clientDetails.confUniqueSnapshots!=undefined)?(this.clientDetails.clientDetails.UniqueSnapshots.length):this.clientDetails.clientDetails.UniqueStudies.length;

    this.isLoading = true;

    if (!this.clientDetails?.clientDetails?.client_name) {
      this.isLoading = false;
      return;
    }

    this._configService
      .getConfigurationByClientName(this.clientDetails.clientDetails.client_name)
      .subscribe((c) => {
          let data = JSON.parse(c.Data);
          this._configService.clientData = data;
          this.fromngOnInit = true;

          this._configService.productSelected = "Standard";

          this.ProductTemplateData();

          const addsnapshot = document.querySelector(
            '.addsnapshot'
          ) as HTMLInputElement;
          if (this.clientDetails.snapshotCount >= 20) {
            addsnapshot?.classList.add('disabled');
            if (addsnapshot) addsnapshot.title = 'You have reached the maximum limit of 20 snapshots. Please delete an existing snapshot before adding a new one.';
          }
          else {
            addsnapshot?.classList.remove('disabled');
            if (addsnapshot) addsnapshot.title = 'Add Snapshot'
          }

          this._configService.clientName =
            this.clientDetails.clientDetails.client_name;
          const receivedData = history.state.data; // Retrieve the data
          this._configCustomService.recievedStatusDataOnBackButtonClick = receivedData;
          if (this.clientDetails.clientDetails.study == "") {
            this.addSnapshot();
            this.showModuleConfigCondition = false;
            this.enableWidgetLibrarySection = true;
            this.isLoading = false;
          }
          if (receivedData != undefined && receivedData.enableWidgetLibrary == true) {
            this.isback = receivedData.dontshowWidgetLibrary ? false : true; // to handle metric configuration "dontshowWidgetLibrary"
            // this.showWidgetLibraryCondition = receivedData.enableWidgetLibrary;
            // this.showModuleConfigCondition = !receivedData.enableWidgetLibrary;
            let p = this._configService.alreadySavedSnapshotData?.product?.toLowerCase();
            this.productSelectedValue = p;
            this.snapshotShow = receivedData.enableWidgetLibrary;
            this.enableWidgetLibrarySection = !receivedData.enableWidgetLibrary;
            this.clientSnapshotNames = receivedData.clientDetails.clientDetails.configdata.filter(
              (m: any) => m.ClientName == receivedData.clientDetails.clientDetails.client_name
            ).map((m: any) => ({
              ...m,
              UniqueSnapshots: Array.isArray(m.UniqueSnapshots) && m.UniqueSnapshots.length > 0
                ? m.UniqueSnapshots
                    .map((u: any) => {
                      // Handle both strings and objects
                      if (typeof u === 'string') {
                        return u; // Keep strings as-is
                      } else if (u.SnapshotName && u.SnapshotName.trim() !== '') {
                        return u.SnapshotName; // Extract valid SnapshotName from objects
                      }
                      return null; // Filter out objects with empty/invalid SnapshotName
                    })
                    .filter((name: any) => name !== null) // Remove nulls
                : m.UniqueSnapshots
            }));
            this.clientSnapshotNames = this.clientSnapshotNames[0].UniqueSnapshots;
            this.clientDetails.snapshotCount = this.clientSnapshotNames.length;
            this.clientSnapshotNameObject = [];
            this.clientSnapshotNames.forEach((name: any) => {
              this.clientSnapshotNameObject.push({
                studyname: name,
                selected: receivedData.clientDetails.clientDetails.study == name ? true : false,
              });
            });
            let newStudyindex = this.clientSnapshotNameObject.findIndex((item: any) => item.studyname === receivedData.clientDetails.clientDetails.study);
            this.clientDetails.clientDetails.client_name = receivedData?.clientDetails?.clientDetails?.client_name;
            this.clientDetails.clientDetails.study = receivedData?.clientSnapshotNameObject ? receivedData?.clientSnapshotNameObject[newStudyindex]?.studyname : receivedData?.clientDetails?.clientDetails.study;
            if (this.selectedSnapshot) this.selectedSnapshot.snapshotName = receivedData?.clientSnapshotNameObject ? receivedData?.clientSnapshotNameObject[newStudyindex]?.studyname : '';
            if (this.clientSnapshotNameObject && this.clientSnapshotNameObject[newStudyindex]) this.clientSnapshotNameObject[newStudyindex].selected = true;
            this.clientDetails.clientDetails.configdata =
              receivedData?.clientDetails?.clientDetails?.configdata?.map(
                (m: any) => {
                  const snapshotNames = this.mapClientUniqueSnapshots(m);
                  return {
                    ...m,
                    UniqueSnapshots: snapshotNames.length
                      ? snapshotNames
                      : m.UniqueSnapshots,
                  };
                },
              );
            this.enableWidgetLibrarySection = false;
            // this.clientDetails.snapshotCount = (this.clientDetails.clientDetails.UniqueSnapshots != undefined) ? (this.clientDetails.clientDetails.UniqueSnapshots.length) : this.clientDetails.clientDetails.UniqueStudies.length;
          }

          const clientNameArea = document.querySelector('.client-name-area');
          if (clientNameArea) {
            clientNameArea.textContent = this.clientDetails.clientDetails.client_name;
          }

          this.showModuleConfigCondition = false;
          if (this.clientDetails.clientDetails.snapshotselected || this.clientDetails.clientDetails.study) {
            // this.selectedStudy(this.clientDetails.clientDetails.snapshotselected);
             this.selectedStudy(this.clientDetails.clientDetails.snapshotselected !== undefined 
                && this.clientDetails.clientDetails.snapshotselected !== null?
              this.clientDetails.clientDetails.snapshotselected : this.clientDetails.clientDetails.study
            );
            this.istemplateselected = true;
          }
          if (this.isback) {
            this.isLoading = true;
            this.cdr.detectChanges();
            setTimeout(() => {
              this.showModuleConfigCondition = false;
              this.showWidgetLibraryCondition = true;
              this.enableWidgetLibrarySection = false; // Show the component again
              this.istemplateselected = true;
              this.isback = false;
              // this.cdr.detectChanges();
            }, 0); // Short delay
            if (this.productSelectedValue == 'custom' && this.showWidgetLibraryCondition) {
              setTimeout(() => {
                this.isLoading = false;
              }, 5000)
            }
            else {
              this.isLoading = false;
            }
          }
        this.UpdateProductTemplateDropdown();

        if (this._configService.afterRefreshShowModuleConfig) {
          this.showModuleConfig();
          this.cdr.detectChanges();
        }

        if (this.clientDetails.clientDetails.study) {
          this.snapshotShow = true;
        }
        if (!this.isback && this.isLoading) {
          this.isLoading = false;
        }
      },
      (error) => {
        console.error('Error loading configuration data:', error);
        this.isLoading = false;
      });

  }
  loadedComponent:any;


  handleNumeralPopUPeventdata:boolean=false;
  handleNumeralPopUP($event:any) {
    this.handleNumeralPopUPeventdata=false;
   this._configCustomService.handleNumeraleventdata=$event;
   this.handleNumeralPopUPeventdata=true;
   this.isNumeral=false;
  }
  addnumeraleventdata:boolean=false;
  addNumeral($event:any) {
    this.addnumeraleventdata=false;
    setTimeout(() => {
      this._configCustomService.addNumeraleventdata = $event;
      this.addnumeraleventdata = true; // Reassign true after a brief delay
      this.isNumeral = false;
    });
  }

  handleNumeralChange($event:any){
     this.isNumeral=$event;
  }

  handleLoader($event:any){
    this.showLoaderPopUp=$event;
  }
 
  UpdateProductTemplateDropdown = async () => {
    //this.isLoading = true;
    if (this.clientDetails.clientDetails.client_name != "" && this.clientDetails.clientDetails.study != "") {
      // Prevent duplicate calls for the same snapshot
      const currentSnapshotKey = `${this.clientDetails.clientDetails.client_name}_${this.clientDetails.clientDetails.study}`;
      if (this.isUpdatingProductTemplate || this.lastUpdatedSnapshot === currentSnapshotKey) {
        return;
      }
      
      this.isUpdatingProductTemplate = true;
      
      try {
        const b = await firstValueFrom(
          this._configService.getClientStudyData({
            client_code: this.clientDetails.clientDetails.client_name,
            snapshot_name: this.clientDetails.clientDetails.study,
          })
        );
        
        
        this.clientStudyApiData = b;
      
        if (b.body.Data != undefined && b.body.Data != "" && b.body.Data != null) {
          this._configService.alreadySavedSnapshotData = JSON.parse(b.body.Data);
          this.lastUpdatedSnapshot = currentSnapshotKey;

          this.product = this.product.map((p: any) => {
            if (p.name == this._configService.alreadySavedSnapshotData.product) {
              return {
                ...p,
                selected: true,
              };
            } else {
              return {
                ...p,
                selected: false,
              };
            }
          });

          this.product.sort((a: any, b: any) => {
            // Put selected products at the top of the list
            return a.selected === b.selected ? 0 : a.selected ? -1 : 1;
          });

          if (this.product[0]?.name == "Standard" && this.product[0]?.selected == true) {
            this.isStandardProduct = true;
            this.istemplateselected = true;
            this.showModuleConfigCondition = true;
          } else {
            this.isStandardProduct = false;
            this.istemplateselected = true;
            this.showModuleConfigCondition == this.isback ? false : true;
            this._configService.templateSelected = "";
          }

          this.template = this.template.map((p: any) => {
            if (p.name == this._configService.alreadySavedSnapshotData.product_type) {
              return {
                ...p,
                selected: true,
              };
            } else {
              return {
                ...p,
                selected: false,
              };
            }
          });

          setTimeout(() => {
            this._configService.productSelected = this._configService.alreadySavedSnapshotData.product;
            let p = this._configService.alreadySavedSnapshotData.product.toLowerCase();
            this.productSelectedValue = p;
            this._configService.templateSelected = this._configService.alreadySavedSnapshotData.product_type;
            let t = this._configService.alreadySavedSnapshotData.product_type.replace(/\W+/g, '').toLowerCase();
            this.templateSelectedValue = t;
          }, 100);
          this.cdr.detectChanges();


          this.isLoading = false;
        }else{         
           this.selectedSnapshot = {
              clientName: '',
              snapshotName: '',
            };
           this.isLoading = false;
        }
      }
      catch (error) {
        // Handle the error
        console.error(error);
      } finally {
        this.isUpdatingProductTemplate = false;
      }
    } else if (this.isLoading) {
      this.isLoading = false;
    }
  }



  ProductTemplateData = async () => {
    this.subscriptions.add(
      await this._configService.getModuleConfigProperties().subscribe((data) => {

        this._configService.moduleConfigPropertiesEnableDisable = JSON.parse(data.Data);

        this.template = this._configService.moduleConfigPropertiesEnableDisable.map((item: any) => {
          if (item.Template != "NA") {
            return {
              name: item.Template,
              value: item.Template.replace(/\W+/g, '').toLowerCase(),
              selected: false
            }
          } else
            return;
        });
        this.template = this.template.filter((item: any) => item != undefined);

        this.product = this._configService.moduleConfigPropertiesEnableDisable.map((item: any) => {
          return {
            name: item.Product,
            value: item.Product.replace(/\W+/g, '').toLowerCase(),
            selected: false
          }
        });
      }));

  }

  productSelected(event: any) {
    this.product.forEach((p: any) => {
      if (p.value == event.target.value) {
        p.selected = true;
        this._configService.productSelected = p.name;
      }
      else {
        p.selected = false;
      }
    });
    this.product.sort((a: any, b: any) => {
      // Put selected products at the top of the list
      return a.selected === b.selected ? 0 : a.selected ? -1 : 1;
    });
    if (this.product[0].name == "Standard" && this.product[0].selected == true) {
      this.isStandardProduct = true;
      this.istemplateselected = false;
      this.showModuleConfigCondition = false;
    } else {
      this.isStandardProduct = false;
      this.istemplateselected = true;
      this.showModuleConfigCondition = false;
      setTimeout(() => {
        this.showModuleConfigCondition = true;
      }, 0); // Short delay

    }
    this.dropdown.nativeElement.selectedIndex = 0;

  }
  templateSelected(event: any) {
    this.template.forEach((p: any) => {
      if (p.value == event.target.value) {
        p.selected = true;
        this.istemplateselected = true;
        this.showModuleConfigCondition = true;
        this._configService.templateSelected = p.name;
      }
      else {
        p.selected = false;
      }
    });
    // if(this.product[0].name=="Standard" && this.product[0].selected==true){this.isStandardProduct=true;}else{this.isStandardProduct=false;}

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes[this.snapID]) {
      // The snapID has changed. Re-initialize the component state here.
      this.showWidgetLibraryCondition = false;
      this.showModuleConfigCondition = false;
      this.snapshotShow = false;
    }
  }


  result: any;
  async loadClientData() {
    try {
      this.result = await firstValueFrom(this._configService1.getSnapshotlandingClientList());
    }
    catch (error) {
      console.error('Error loading client data:', error);
    }
  }

  clientSnapshotNameObject: any = [];
  configData: any;
  constructor(
    private snapshotCount: SnapshotSharedVariablesService,
    public _configService: SnapshotService,
    private _configService1: SharedPopupService,
    private clientDetails: SnapshotSharedVariablesService,
    private snapshotDetails: SnapshotSharedVariablesService,
    private _loaderService: LoaderService,
    private router: Router, private cdr: ChangeDetectorRef,
    private _configCustomService: CustomsnapshotService,
    private _cdRef: ChangeDetectorRef
  ) {
    this._configService.afterRefreshShowModuleConfig = false;
    // this._configService1.getSnapshotlandingClientList().subscribe((result) => {
    //   if (result.HasValidData) {
    //     this.configData = JSON.parse(result.Data);

    //   }
    // });
    // this.loadClientData();


    const navigation = this.router.getCurrentNavigation();
    const receivedData = history.state.data;
    if (navigation?.extras.state && navigation?.extras.state['deletedsnapshot'] == undefined && navigation?.extras.state['data'] == undefined) {
      this.clientDetails.clientDetails = navigation?.extras
        .state as SnapshotSharedVariablesService;

      this.buildSnapshotTabsFromClientConfig();
    }
    if (navigation?.extras.state && navigation?.extras.state['deletedsnapshot'] != undefined && navigation?.extras.state['data'] == undefined) {
      const snapshottodelete = navigation?.extras.state['deletedsnapshot'];
      if (this.clientDetails?.clientDetails?.configdata?.length) {
        this.removeSnapshotFromConfig(
          this.clientDetails.clientDetails.client_name,
          snapshottodelete,
        );
        this.rebuildSnapshotTabsAfterDelete();
      }
    }
    else if (navigation?.extras.state && navigation?.extras.state['data'] != undefined && this._configService.fromBackButton != true) {
      this.clientDetails.clientDetails = navigation?.extras.state["data"]?.clientDetails.clientDetails;
      this.buildSnapshotTabsFromClientConfig();
      this._configService.afterRefreshShowModuleConfig = true;
    }

  }

  /** Supports UniqueSnapshots entries as strings (new saves) or { SnapshotName } objects (legacy). */
  private normalizeSnapshotName(entry: any): string {
    if (typeof entry === 'string') {
      return entry.trim();
    }
    return (entry?.SnapshotName ?? '').trim();
  }

  private mapClientUniqueSnapshots(client: any): string[] {
    if (!client?.UniqueSnapshots || !Array.isArray(client.UniqueSnapshots)) {
      return [];
    }
    return client.UniqueSnapshots
      .map((entry: any) => this.normalizeSnapshotName(entry))
      .filter((name: string) => name !== '');
  }

  private buildSnapshotTabsFromClientConfig(): void {
    const clientName = this.clientDetails?.clientDetails?.client_name;
    const configdata = this.clientDetails?.clientDetails?.configdata;
    if (!clientName || !configdata?.length) {
      return;
    }

    const clientConfig = configdata.find(
      (m: any) => m.ClientName === clientName,
    );
    const snapshotNames = clientConfig
      ? this.mapClientUniqueSnapshots(clientConfig)
      : [];
    const currentStudy = this.clientDetails.clientDetails.study;

    this.clientSnapshotNameObject = snapshotNames.map((studyname: string) => ({
      studyname,
      selected: currentStudy === studyname,
    }));
    this.clientSnapshotNames = snapshotNames;
    this.clientDetails.snapshotCount = snapshotNames.length;
    this._configService.clientAllSnapshotNames = snapshotNames;

    if (snapshotNames.length > 0) {
      this.snapshotShow = true;
      const hasValidStudy =
        currentStudy && snapshotNames.includes(currentStudy);
      if (!hasValidStudy) {
        this.clientSnapshotNameObject.forEach((item: any) => {
          item.selected = false;
        });
        this.clientSnapshotNameObject[0].selected = true;
        this.clientDetails.clientDetails.study =
          this.clientSnapshotNameObject[0].studyname;
      }
      this.selectedSnapshot = {
        clientName: clientName,
        snapshotName: this.clientDetails.clientDetails.study,
      };
    }
  }

  /** After delete: select first remaining tab and refresh shared popup list. */
  private rebuildSnapshotTabsAfterDelete(): void {
    const clientName = this.clientDetails.clientDetails.client_name;
    const clientConfig = this.clientDetails.clientDetails.configdata?.find(
      (m: any) => m.ClientName === clientName,
    );
    const snapshotNames = clientConfig
      ? this.mapClientUniqueSnapshots(clientConfig)
      : [];

    this.clientSnapshotNameObject = snapshotNames.map((studyname: string) => ({
      studyname,
      selected: false,
    }));
    this.clientSnapshotNames = snapshotNames;
    this.clientDetails.snapshotCount = snapshotNames.length;
    this.snapshotPageIndex = 0;

    if (this.clientSnapshotNameObject.length > 0) {
      this.clientSnapshotNameObject[0].selected = true;
      this.activeSnapshotIndex = 0;
      this.clientDetails.clientDetails.study =
        this.clientSnapshotNameObject[0].studyname;
      this.selectedSnapshot = {
        clientName: clientName,
        snapshotName: this.clientSnapshotNameObject[0].studyname,
      };
      this.snapshotShow = true;
      this.showModuleConfigCondition = true;
      this.isExisting = true;
    } else {
      this.clientDetails.clientDetails.study = '';
      this.showModuleConfigCondition = false;
      this.snapshotShow = false;
    }

    this.syncPopupSnapshotList(clientName, snapshotNames);
  }

  private removeSnapshotFromConfig(
    clientName: string,
    snapshotToDelete: string,
  ): void {
    const client = this.clientDetails.clientDetails.configdata?.find(
      (element: any) => element.ClientName === clientName,
    );
    if (!client?.UniqueSnapshots || !Array.isArray(client.UniqueSnapshots)) {
      return;
    }
    client.UniqueSnapshots = client.UniqueSnapshots.filter(
      (entry: any) =>
        this.normalizeSnapshotName(entry) !== snapshotToDelete.trim(),
    );
  }

  private syncPopupSnapshotList(
    clientName: string,
    snapshotNames: string[],
  ): void {
    const popupClients = this._configService.SnapshotList;
    if (!popupClients?.length) {
      return;
    }
    const client = popupClients.find((c: any) => c.ClientName === clientName);
    if (client) {
      client.UniqueSnapshots = [...snapshotNames];
    }
  }

  enableWidegtLibrary(condition: any) {
    this.enableWidgetLibrarySection = condition;
  }
  isExisting: boolean = false;
  setexistingFlag(flag: any) {
    this.isExisting = flag;
  }
  showWidgetLibrary() {
    const snapshotConfigurationTabs = document.querySelector(
      '.general_configuaration'
    );
    const w2idgetLibraryTabs = document.querySelector('.widget_library');

    this.hideClientDashboard = true;
    this.hideProductDropdown = true;
    this.hideTemplateDropdown = true;

    this.showWidgetLibraryCondition = true;
    this.showModuleConfigCondition = false;
    this.showAdditonalConfigCondition = false;
    this.showTopicsConfigCondition = false;
  }
  showAdditonalConfig(){
    this.hideClientDashboard = true;
    this.hideProductDropdown = true;
    this.hideTemplateDropdown = true;

    this.showWidgetLibraryCondition = false;
    this.showModuleConfigCondition = false;
    this.showAdditonalConfigCondition = true;
    this.showTopicsConfigCondition = false;
  }
  showTopicsConfig(){
    this.hideClientDashboard = true;
    this.hideProductDropdown = true;
    this.hideTemplateDropdown = true;

    this.showWidgetLibraryCondition = false;
    this.showModuleConfigCondition = false;
    this.showAdditonalConfigCondition = false;
    this.showTopicsConfigCondition = true;
  }
  showModuleConfig() {
    const snapshotConfigurationTabs = document.querySelector(
      '.general_configuaration'
    );
    const w2idgetLibraryTabs = document.querySelector('.widget_library');


    this.showWidgetLibraryCondition = false;

    this.showModuleConfigCondition = true;
    this.enableAdditonalConfig = false;
    this.showAdditonalConfigCondition = false;
    this.showTopicsConfigCondition = false;

    this.hideClientDashboard = false;
    this.hideProductDropdown = false;
    this.hideTemplateDropdown = false;
  }
  isAddsnapshotclicked = false;
  addSnapshot() {
    sessionStorage.removeItem('isSTF');
    this.isExisting = false;
    this.hideProductDropdown = false;
    this.hideTemplateDropdown = false;
    this.showWidgetLibraryCondition = false;
    this.showAdditonalConfigCondition = false;

    this.istemplateselected = false;
    this.isAddsnapshotclicked = true;
    this._configService.ifDataExists = false;
    this.clientSnapshotNameObject.forEach((object: any) => {
      object.selected = false;
    });
    this.showModuleConfigCondition = false;
    this.selectedSnapshot = {
      clientName: '',
      snapshotName: '',
    };
    this.clientDetails.clientDetails.study = "";

    this.product = this.product.map((p: any) => {
      if (p.name === "Standard") {
        return {
          ...p,
          selected: true,
        };
      } else {
        return {
          ...p,
          selected: false,
        };
      }
    });

    this.product.sort((a: any, b: any) => {
      // Put selected products at the top of the list
      return a.selected === b.selected ? 0 : a.selected ? -1 : 1;
    });
    this.isStandardProduct = true;
    this._configService.productSelected = "Standard";
    this.templateSelectedValue = "select";
    this.template = this.template.map((p: any) => {
      if (p.value == this.templateSelectedValue) {
        return {
          ...p,
          selected: true,
        };
      }
      else {
        return {
          ...p,
          selected: false,
        };
      }
    });
    // this.snapshotCount.snapshotCount++;
    this.snapID = this.snapshotCount.snapshotCount;
    this.snapshotShow = true;
    setTimeout(() => {
      this.showModuleConfigCondition = false; // Show the component again
    }, 0); // Short delay
    // this.showModuleConfig();
  }

  selectedSnapshot: any;

  get currentStudyForConfig(): string {
    return this.clientDetails?.clientDetails?.selectedStudy || '';
  }

  selectedStudy(studynames: any, localIndex: number = 0) {
    //this.isLoading = true;
    this.activeSnapshotIndex = this.snapshotPageIndex * this.snapshotVisibleCount + localIndex;

    this.enableWidgetLibrarySection = false;
    let stdname = studynames.studyname != undefined ? studynames.studyname : studynames;
    this.isAddsnapshotclicked = false;
    this.showModuleConfigCondition = false;
    this.enableAdditonalConfig=false;
    this.showAdditonalConfigCondition=false;
    this.showTopicsConfigCondition=false;
    const dropdownContainer = document.querySelector('.dropdown-container') as HTMLElement;
    if (dropdownContainer) {
      dropdownContainer.style.display = 'flex';
    }
    this.clientSnapshotNameObject.forEach((object: any) => {
      if (object.studyname == stdname) {
        object.selected = true;
      } else {
        object.selected = false;
      }
    });

    this.clientDetails.clientDetails.study = studynames.studyname != undefined ? studynames.studyname : studynames;
    this.clientDetails.clientDetails.snapshotselected = studynames.studyname != undefined ? studynames.studyname : studynames;
   
    this.clientDetails.clientDetails.selectedStudy = '';
    this.selectedSnapshot = {
      clientName: this.clientDetails.clientDetails.client_name,
      snapshotName: studynames.studyname != undefined ? studynames.studyname : studynames,
    };
    if(this._configCustomService.client!==this.clientDetails.clientDetails.client_name || this._configCustomService.snapshot!==this.clientDetails.clientDetails.study){
    this._configCustomService.selectedSubsection="";
    this._configCustomService.selectedSection="";
    this._configCustomService.selectedSnapshotName="";
    this._configCustomService.widgetSaveObjectCustom=[];
    if(this._configCustomService.recievedStatusDataOnBackButtonClick)
      {
        this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack=false;
        this._configCustomService.isBack=false;
      }
    }
    this.snapshotShow = true;
    setTimeout(() => {
      this.showWidgetLibraryCondition = false;
      this.showModuleConfigCondition = this.isback ? false : true; // Show the component again
    }, 0); // Short delay
    if (!this.fromngOnInit) {
      this.ProductTemplateData();
    }
    this.fromngOnInit = false;
    this.istemplateselected = true;
    // Reset the cache when switching to a different snapshot
    this.lastUpdatedSnapshot = '';
    this.clientStudyApiData = null; // Clear the stored data when switching snapshots
    this.UpdateProductTemplateDropdown();
    //this.isLoading = true;
  }

  handleSubmission(event: any) {
    this.enableWidgetLibrarySection = true;

  }

snapshotPageIndex = 0;          
snapshotVisibleCount = 6;       
activeSnapshotIndex = 0;        

get visibleSnapshots() {
  const start = this.snapshotPageIndex * this.snapshotVisibleCount;
  return this.clientSnapshotNameObject.slice(start, start + this.snapshotVisibleCount);
}

showPrevSnapshot() {
  if (this.canShowPrevSnapshot) {
    this.snapshotPageIndex--;
  }
}

showNextSnapshot() {
  if (this.canShowNextSnapshot) {
    this.snapshotPageIndex++;
  }
}

get canShowPrevSnapshot() {
  return this.snapshotPageIndex > 0;
}

get canShowNextSnapshot() {
  return (this.snapshotPageIndex + 1) * this.snapshotVisibleCount < this.clientSnapshotNameObject.length;
}

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();
  }
}
